export const VITRINA_CRM_EVENT = {
  visited: 'MfoVitrinaVisitedSF',
  clicked: 'MfoVitrinaClickedSF',
  zayavka: 'MfoVitrinaZayavkaSF',
  zaim: 'MfoVitrinaZaimSF',
} as const;

export type CrmEventAction = (typeof VITRINA_CRM_EVENT)[keyof typeof VITRINA_CRM_EVENT];

export type CrmApplicationStatus = 'refused' | 'pending';

export type CrmChannel = '' | 'web' | 'app';

export const VITRINA_CRM_CAMPAIGN = {
  visited: 'sravni_mfocred_vitrina_visited_crm',
  clicked: 'sravni_mfocred_vitrina_clicked_crm',
  zaim: 'sravni_mfocred_vitrina_zaim_crm',
  zayavkaRefused: 'sravni_mfocred_vitrina_refused_crm',
  zayavkaPending: 'sravni_mfocred_vitrina_pending_crm',
} as const;

export type CrmEventRequest = {
  eventAction: CrmEventAction;
  appId?: CrmChannel;
  mfoFD?: CrmChannel;
  zayavkaKind?: CrmApplicationStatus;
};

export const VITRINA_CRM_EVENT_ACTIONS = new Set<string>(Object.values(VITRINA_CRM_EVENT));
